import _ from 'lodash';

export const hasInviteToken = ({ user }) => {
  if (!user) return false;

  const { invitationToken } = user;
  return invitationToken !== null;
};

export const hasResetToken = ({ user }) => {
  if (!user) return false;

  const { resetPasswordToken } = user;
  return resetPasswordToken !== null;
};

export const hasTFARequestToken = ({ deviseAuth }) => {
  const token = _.get(deviseAuth, 'otp.tfaRequestToken', null);
  return token !== null;
};
